import { AccreditationPayload } from 'services/interfaces/accreditation';
import { onlyNumbers } from 'shared/helpers/string';
import { mapUiFeeToItem, parseFreePixFeeValue } from './buildFreePixFeePayload';
import { AccreditationFormValues } from './buildAccreditationPrefill';

function optionalBankField(value: string): string | null {
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
}

export function buildAccreditationPayload(args: {
  form: AccreditationFormValues;
  customerId: number;
  idi: number;
}): AccreditationPayload {
  const { form, customerId, idi } = args;
  const document = onlyNumbers(form.document);
  const holderDocument = onlyNumbers(form.holderDocument);
  const pixKey = form.pixKey.trim();
  const feeValor = parseFreePixFeeValue(form.feeValue);

  const bank = {
    pixKey,
    pixKeyType: form.pixKeyType,
    holderName: form.holderName.trim(),
    holderDocument,
    bankName: optionalBankField(form.bankName),
    bankNumber: optionalBankField(form.bankNumber),
    agency: optionalBankField(form.agency),
    account: optionalBankField(form.account),
    accountDigit: optionalBankField(form.accountDigit),
  };

  const businessName = form.businessName.trim();
  const fees = [mapUiFeeToItem(feeValor, form.feeType)];

  return {
    customerId,
    marketplace: {
      tradeName: form.tradeName.trim(),
      ...(businessName ? { businessName } : {}),
      document,
      originId: String(idi),
      bank,
      fees,
    },
    banking: {
      userIdi: idi,
      ...bank,
    },
    marketplaceFees: fees,
  };
}
